import { defineComponent as _defineComponent } from 'vue'
import type { CourseItem } from '@/services/interfaces/Course'
  import type { PropType } from 'vue'
  import { VPopover } from 'v-tooltip'
  import { computed, ref, watch } from 'vue'
  import { useRouter } from 'vue-router/composables'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'StartCourseExamCTA',
  props: {
    course: {
      type: Object as PropType<CourseItem>,
      required: true,
    },
  },
  emits: ['start-exam-cta-clicked'],
  setup(__props, { emit }) {

const props = __props;

  const { formatDate, courseExpiryDuration } = useCommonMixin()

  const router = useRouter()

  

  

  const hoveringStartExamCTA = ref(false)
  const showExpiredCourseTooltip = ref(false)

  const expired = computed(() => props.course?.expired)

  const expiredAt = computed(() => props.course?.expiredAt ?? null)

  watch(hoveringStartExamCTA, (value) => {
    showExpiredCourseTooltip.value = value && expired.value
  })

  const routeToExam = () => {
    if (expired.value || !props.course?.exam?.id) return

    emit('start-exam-cta-clicked')
    router.push(`/courses/${props.course.id}/exam/${props.course.exam?.id}/start`).catch(() => {
      return
    })
  }

return { __sfc: true,formatDate, courseExpiryDuration, router, props, emit, hoveringStartExamCTA, showExpiredCourseTooltip, expired, expiredAt, routeToExam, VPopover, computed, ref, watch, useRouter, useCommonMixin }
}

})